import { formatURIComponent } from "./utils"

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=owner&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '华美服务 = 咨询服务 + 华美云 + 尽管问',
        pageTitle: '业主监管',
        pageTitleIcon: '',
        background_img: '/backgrounds/sunny.jpg',
        description: `华美通过系统性的运营监控、财务审计和品牌标准合规检查，确保管理团队高效执行合同条款，同时优化成本结构和收益表现。常见问题包括管理方偏离授权预算、绩效数据不透明、能耗及人力成本超支等。华美采用数据驱动的监管体系，及时发现经营偏差并提出纠偏方案。`,
        icons: [
            {
                name: '业主监管',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/12.业主监管.pdf'),
                path: "四库赋能-酒店资管/业主监管/成功案例"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店资管/业主监管/华美项目"
            },
            {
                name: '数据赋能',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/业主监管/数据赋能'),
                path: "四库赋能-酒店资管/业主监管/数据赋能"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/业主监管/全球案例/全球案例（业主监管）.xlsx'),
                path: "四库赋能-酒店资管/业主监管/全球案例"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/业主监管/预警问题/预警问题（业主监管）.xlsx'),
                path: "四库赋能-酒店资管/业主监管/预警问题"
            },
        ]
    }]
}